import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import Link from './Link'
import Button from './Button'
import Icon from './Icon'

const ICON_CLASS = 'arrow-link__icon icon icon--extra-small baseline-align'

export default function ArrowLink ({
  label,
  iconLeft,
  extraClass,
  ...linkProps
}) {
  const content = (
    <>
      {iconLeft && (
        <span className='no-wrap'>
          <Icon
            icon='arrow'
            className={classnames('arrow-link__icon--left', ICON_CLASS)}
          />
          &#xfeff;
        </span>
      )}
      {label}
      {!iconLeft && (
        <span className='no-wrap'>
          &#xfeff;
          <Icon
            icon='arrow'
            className={classnames('arrow-link__icon--right', ICON_CLASS)}
          />
        </span>
      )}
    </>
  )
  const classes = classnames(extraClass, 'arrow-link heading bold')

  if (!linkProps.href && linkProps.onClick) {
    return (
      <Button {...linkProps} variation='plain' extraClass={classes}>
        {content}
      </Button>
    )
  }

  return (
    <Link className={classes} {...linkProps}>
      {content}
    </Link>
  )
}

ArrowLink.propTypes = {
  label: PropTypes.string.isRequired,
  extraClass: PropTypes.string,
  linkProps: PropTypes.object,
  iconLeft: PropTypes.bool
}
